import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import FolderScopeMenuItem from '../schema/FolderScopeMenuItem';
import getFolderDisplayNameFromId from 'owa-mail-store/lib/utils/getFolderDisplayNameFromId';
import searchStore from 'mini-mail-search-store/lib/store/Store';
import strings from 'owa-strings/owa-mini-strings';
import { getIconForFolder } from './getIconForFolder';
import { getMailSearchStore } from 'mini-3s-mail-search-store/lib/store/Store';
import { getStore } from 'mini-mail-folder-store/lib/store/Store';
import { isMiniFeatureEnabled } from 'owa-mini-feature-flags';

/**
 * Returns Favourite folders in FolderScopeMenuItem format
 */
export default function getFolderScopeItems(): FolderScopeMenuItem[] {
    const { orderedFavoritesFolderIds } = getStore();
    const allFoldersId: string = folderNameToId('msgfolderroot');

    // WI #89122 : Clean up this code once UnifiedSearch is 100%
    const isUnifiedSearchFlagEnabled = isMiniFeatureEnabled('mini-unified-search');
    const { currentFolderScopeId, lastSelectedMailFolderId } = getMailSearchStore();
    const { staticFolderScopeId, previouslySelectedFolderId } = searchStore;
    const selectedFolderId = isUnifiedSearchFlagEnabled
        ? currentFolderScopeId
        : staticFolderScopeId;
    const previousFolderId = isUnifiedSearchFlagEnabled
        ? lastSelectedMailFolderId
        : previouslySelectedFolderId;

    let folderScopeItems: FolderScopeMenuItem[] = [];
    const allFoldersScopeItem: FolderScopeMenuItem = {
        icon: getIconForFolder(allFoldersId),
        folderId: allFoldersId,
        folderDisplayName: strings.allFolders,
    } as FolderScopeMenuItem;

    folderScopeItems.push(allFoldersScopeItem);
    const favouriteFoldersScopeItems: FolderScopeMenuItem[] = orderedFavoritesFolderIds
        /* Filter out Draft folder */
        .filter(folderId => getFolderDisplayNameFromId(folderId) !== 'Drafts')
        .map(
            folderId =>
                ({
                    icon: getIconForFolder(folderId),
                    folderId: folderId,
                    folderDisplayName: getFolderDisplayNameFromId(folderId),
                } as FolderScopeMenuItem)
        );
    folderScopeItems = folderScopeItems.concat(favouriteFoldersScopeItems);

    // Check if selected item is already in favourite folders list
    if (!folderScopeItems.some(item => item.folderId === selectedFolderId)) {
        const currentSelectedFolderItem: FolderScopeMenuItem = {
            icon: getIconForFolder(selectedFolderId),
            folderId: selectedFolderId,
            folderDisplayName: getFolderDisplayNameFromId(selectedFolderId),
        } as FolderScopeMenuItem;
        folderScopeItems.push(currentSelectedFolderItem);
    }

    // Check if previously selected item is already in selected folders list
    if (!folderScopeItems.some(item => item.folderId === previousFolderId)) {
        const currentSelectedFolderItem: FolderScopeMenuItem = {
            icon: getIconForFolder(previousFolderId),
            folderId: previousFolderId,
            folderDisplayName: getFolderDisplayNameFromId(previousFolderId),
        } as FolderScopeMenuItem;
        folderScopeItems.push(currentSelectedFolderItem);
    }

    return folderScopeItems;
}
